import React from 'react';
import { paths } from 'client/shared/Paths';
import { TextLink } from '@spotify-internal/anchor-ds';
import { useT } from 'client/i18n/hooks/useT';
import { ButtonPrimary, spacer24, Type } from '@spotify-internal/encore-web';
import { Link } from 'react-router-dom';
import { DeleteContainer, DeleteSection } from './styles';

export function DeleteAccount() {
  const t = useT();

  return (
    <DeleteSection>
      <Type as="h3" variant="celloCanon">
        {t(
          'SettingsScreen.DeleteAccount.DeleteAccountHeader',
          'Delete account',
          'Delete Anchor account section header'
        )}
      </Type>
      <DeleteContainer>
        <Type
          as="p"
          variant="ballad"
          style={{ margin: `${spacer24} 0` }}
          semanticColor="textSubdued"
        >
          {t(
            'SettingsScreen.DeleteAccount.DeleteAccountMessage',
            'We hope you love using Anchor, but if you need to delete your account you can do that here. If you delete your account, your podcast and all of its content will be permanently removed and cannot be recovered.',
            'Delete Anchor account disclaimer'
          )}
        </Type>
        <Type
          as="p"
          variant="ballad"
          style={{ margin: `${spacer24} 0` }}
          semanticColor="textSubdued"
        >
          {t(
            'SettingsScreen.DeleteAccount.DeleteAccountMoreInfoMessage',
            'Unsure about deleting your account? Reach out to us for help at {helpPageLink}.',
            'More information about deleting Anchor account message',
            {
              helpPageLink: (
                <TextLink
                  href={paths.getHelpPage('home')}
                  target="_blank"
                  rel="noopener noreferrer"
                  key="settings-screen__help-page-link"
                >
                  {paths.getHelpPage('home')}
                </TextLink>
              ),
            }
          )}
        </Type>
        <ButtonPrimary
          as={Link}
          {...{ to: '/dashboard/delete' }}
          colorSet="negative"
          style={{ textDecoration: 'none' }}
        >
          {t(
            'SettingsScreen.DeleteAccount.DeleteButtonLabel',
            'Delete my account',
            'Delete Anchor account button text'
          )}
        </ButtonPrimary>
      </DeleteContainer>
    </DeleteSection>
  );
}
